import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Amplify v6 REST API. The legacy `aws_cloud_logic_custom` block in
// aws-exports.js is enough for v6 to know the endpoint URL, but it does NOT
// carry the `service: 'execute-api'` flag that tells Amplify to sign
// requests with SigV4 from the Cognito Identity Pool. Without that flag,
// `aws-amplify/api` sends UNSIGNED requests and the API Gateway AWS_IAM
// authorizer returns 403 "Missing Authentication Token". Explicitly
// configure the REST endpoint in the v6 format so signing is enabled.
const restEndpoint = awsExports?.aws_cloud_logic_custom?.[0];
Amplify.configure({
  ...awsExports,
  // The identity pool has guest (unauthenticated) identities switched off.
  // Without this flag Amplify v6 assumes guest access is allowed, so every
  // fetchAuthSession() from a signed-out visitor (e.g. the 10s balance poll
  // on demo pages) calls cognito-identity GetId and gets 400 "Unauthenticated
  // access is not supported for this identity pool". 'enable' sets
  // Auth.Cognito.allowGuestAccess = false. aws-exports.js is regenerated by
  // the Amplify CLI, so the override lives here.
  aws_mandatory_sign_in: 'enable',
  API: {
    REST: {
      [restEndpoint?.name || 'atlasCasinoApi']: {
        endpoint: restEndpoint?.endpoint,
        region: restEndpoint?.region,
        service: 'execute-api',
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
